import PropTypes from 'prop-types';
import React from 'react';
import { omit } from 'lodash';
import { isNativeWrapper, sendCommand } from '../utils/mobile';

const RemoteLink = (props) => {
  const handler = (event) => {
    if (isNativeWrapper()) {
      event.preventDefault();
      event.stopPropagation();
      sendCommand('open-link', { href: props.href });
      return false;
    }

    // do nothing, keep default implementation
    return true;
  };

  const restProps = omit(props, ['href', 'onClick', 'role']);
  return (
    <a
      href={props.href}
      {...restProps}
      onClick={handler}
      rel="noopener noreferrer"
      target="_blank"
    >
      {props.children}
    </a>
  );
};

RemoteLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
};

export default RemoteLink;



// WEBPACK FOOTER //
// ./src/components/RemoteLink.js